<template>
  <div :class="{ 'risk_control': true, 'risk_control_dark': theme == 'dark' }">
    <header>
      <div class="left">
        <span>气象应急指挥决策辅助平台</span>
      </div>
      <div class="right">
        <div :class="{ 'header_day': true, 'header_dark': theme == 'dark' }">
          <span>{{ day }}</span><span></span><span>{{ time }}</span>
        </div>
        <div @click="changeTheme" class="theme_btn">切换主题</div>
      </div>
    </header>

    <div class="main">
      <div class="main_left">

        <div class="risk_warn">
          <Header title="天气实况" :time="liveTime"></Header>
          <WeatherLive :theme="theme" @changeTime="(val) => liveTime = val" ref="nodeRef1"></WeatherLive>
        </div>

        <div class="weather_warn">
          <Header title="实况排名" :time="liveTimes"></Header>
          <LiveOrder :theme="theme" @changeTime="(val) => liveTimes = val" ref="nodeRef2"></LiveOrder>
        </div>

        <div class="weather_report">
          <Header title="服务统计"></Header>
          <ServiceStatisticsPie :theme="theme" ref="nodeRef3"></ServiceStatisticsPie>
        </div>
      </div>

      <div :class="{ center: true, center_dark: theme === 'dark' }">
        <CenterMap :theme="theme" ref="nodeRef4"></CenterMap>
      </div>

      <div class="main-right">

        <div class="risk_order">
          <Header title="风险排名"></Header>
          <RiskOrder :theme="theme" ref="nodeRef5"></RiskOrder>
        </div>

        <div class="weather_remind">
          <Header title="天气提醒"></Header>
          <!-- <RiskLivePieEchart :theme="theme"></RiskLivePieEchart> -->
          <WeatherRemind :theme="theme" ref="nodeRef6"></WeatherRemind>
        </div>
      </div>
    </div>

    <div class="logo">
      <img src="@/assets/images/logo.png" alt="" />
      <span>气象公共服务中心制作</span>
    </div>
  </div>
</template>

<script>
import Header from '@/components/module/data-center/Header'
import ServiceStatisticsPie from '@/components/module/data-center/ServiceStatisticsPie.vue'
import WeatherRemind from '@/components/module/data-center/WeatherRemind.vue'
import LiveOrder from '@/components/module/data-center/LiveOrder.vue'
import WeatherLive from '@/components/module/data-center/WeatherLive.vue'
import RiskOrder from '@/components/module/data-center/RiskOrder.vue'
import CenterMap from '@/components/module/data-center/CenterMap.vue'
export default {
  name: 'DataCenetr',
  data() {
    return {
      day: '',
      time: '',
      theme: 'dark',
      titleName: '',
      liveTime: '',
      liveTimes: ''
    }
  },
  mounted() {
    this.setTime()
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    const company = this.$route.query.company
    const { unit } = JSON.parse(localStorage.getItem(company))
    this.titleName = unit.sysname
    this.timmer && clearInterval(this.timmer)
    this.timmer = setInterval(() => {
      this.$refs.nodeRef1.getGiftLive()
      this.$refs.nodeRef2.getObjRainSort(unit.id)
      this.$refs.nodeRef3.nowRiskCount(unit.id)
      this.$refs.nodeRef4.objStatusByUnit(unit.id)
      this.$refs.nodeRef4.newestYqtbCont(unit.id)
      this.$refs.nodeRef4.newestYqtbTime()
      this.$refs.nodeRef5.nowRiskSort(unit.id)
      this.$refs.nodeRef6.newTxMsgShiWu(unit.id)
    }, 5000 * 60)
  },
  methods: {
    setTime() {
      this.interTime = setInterval(() => {
        this.day = this.$moment(new Date()).format('YYYY年MM月DD日')
        this.time = this.$moment(new Date()).format('HH:mm:ss')
      }, 1000)
    },
    // 切换主题
    changeTheme() {
      this.theme = this.theme === 'dark' ? 'light' : 'dark'
    }
  },
  beforeDestroy() {
    this.timmer && clearInterval(this.timmer)
  },
  components: { Header, WeatherLive, ServiceStatisticsPie, RiskOrder, CenterMap, LiveOrder, WeatherRemind }
}
</script>

<style lang="less" scoped>
.risk_control {
  display: flex;
  flex-direction: column;
  height: 100vh;
  // background: url('../assets/images/数据监控背景light.png');
  background: #F4F6F8;
  position: relative;

  .theme_btn {
    cursor: pointer;
  }

  .main {
    // display: flex;
    // justify-content: space-between;
    flex: 1;
    position: relative;
  }

  .logo {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0.94vw;
    left: 50%;
    transform: translate(-50%);

    img {
      width: 1.46vw;
    }

    span {
      margin-left: 0.52vw;
      font-size: 0.73vw;
      color: #999999;
    }

  }
}

header {
  float: left;
  width: 100%;
  height: 8.2vh;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0vw 1.5vw 0vw 2.14vw;
  color: #fff;

  .left {
    font-size: 1.88vw;
    font-weight: 600;
    color: #2D74F5;
    line-height: 8.2vh;
  }

  .right {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    color: #333333;

    .header_day {
      display: flex;
      align-items: center;
      padding: 0.84vw 1.41vw;
      font-size: 0.9vw;
      margin-right: 10px;
      background: rgba(247, 249, 252, 1);
      border-radius: 1.51vw;

      span:nth-child(2) {
        height: 0.78vw;
        margin: 0vw 0.63vw;
        border: 1px solid #D1D1D1;
      }

      span:nth-child(3) {
        font-size: 1.15vw;
        font-weight: 600;
      }
    }

  }
}

.main_left {
  display: flex;
  flex-direction: column;
  // flex: 1;.
  width: 27.6vw;
  height: 91.8vh;
  overflow: hidden;
  position: absolute;
  left: 0;
  top: 0;

  .risk_warn {
    display: flex;
    flex-direction: column;
    height: 26vh;
  }

  .weather_warn {
    display: flex;
    flex-direction: column;
    // height: 34vh;
  }

  .weather_report {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
}

.center {
  // width: 100vh;
  width: 47.2vw;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

.main-right {
  display: flex;
  flex-direction: column;
  // width: 464.06px;
  width: 25.52vw;
  height: 91.8vh;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: 0;

  .weather_remind {
    display: flex;
    flex-direction: column;
    // height: 40vh;
    flex: 1;
    overflow: hidden;
  }

  .risk_order {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
}

.risk_control_dark {
  // background: url('../assets/images/数据中心背景dark.png');
  background: #0C2F63;

  .theme_btn {
    color: white;
  }

  .header_day.header_dark {
    background: rgba(227, 233, 239, 0.1);
    color: white;
  }

  .left {
    color: #2d74f5;
  }

  .logo {
    span {
      color: #FFf
    }
  }
}
</style>
